import axios from 'axios'
import auth from '../auth/initAuth'
import ActionsLogin from './LoginActions'
import ParametrosSistemaActions from './ParametrosSistemaActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const endPoint = '/sistema-usuario/'

const cadastrarUsuario = (
  {
    nome,
    cpf,
    telefone,
    email,
    senha,
    cd_perfil,
    idc_status,
    cd_ponto_apoio,
    cd_sistema
  },
  page,
  pathRetorno,
  paramAuth0Conn
) => {
  axios
    .post(
      process.env.URL_API_BASE + endPoint,
    {
      nome: nome,
      cpf: cpf,
      telefone: telefone,
      email: email,
      senha: senha,
      cd_perfil: cd_perfil,
      idc_status: idc_status,
      cd_ponto_apoio: cd_ponto_apoio,
      cd_sistema: cd_sistema
    },
      config
    )
    .then(response => {
      ParametrosSistemaActions
        .getParametro(paramAuth0Conn)
        .then(param => {
          if (param) {
            auth.signup(email, senha, param.valor, (err, result) => {
              page.$parent.$parent.$data.showModalLoader = false
              if (err) {
                console.log(
                  'signup error : ',
                  err.error + ' : ' + err.error_description
                )
                page.errorMessage = 'Ocorreu um erro ao gravar o registro.'
              } else {
                page.$router.push(pathRetorno)
              }
            })
          }
        })
    })
    .catch(error => {
      if (error.response && error.response.data.code) {
        page.errorMessage = error.response.data.error
      } else {
        console.log(error.message)
        page.errorMessage = 'Ocorreu um erro ao gravar o registro.'
      }
      page.$parent.$parent.$data.showModalLoader = false
    })
}

const alterarUsuario = (
  {
    id,
    nome,
    cpf,
    telefone,
    email,
    senha,
    cd_perfil,
    idc_status,
    cd_ponto_apoio,
    cd_sistema
  },
  page,
  pathRetorno
) => {
  axios
    .patch(
      process.env.URL_API_BASE + endPoint + id,
    {
      nome: nome,
      cpf: cpf,
      telefone: telefone,
      email: email,
      senha: senha,
      cd_perfil: cd_perfil,
      idc_status: idc_status,
      cd_ponto_apoio: cd_ponto_apoio,
      cd_sistema: cd_sistema
    },
      config
    )
    .then(response => {
      page.$parent.$parent.$data.showModalLoader = false
    })
    .catch(error => {
      if (error.response && error.response.data.code) {
        page.errorMessage = error.response.data.error
      } else {
        console.log(error.message)
        page.errorMessage = 'Ocorreu um erro ao gravar o registro.'
      }
      page.$parent.$parent.$data.showModalLoader = false
    })
}

const alterarSenha = (id, senha, page, pathRetorno) => {
  const url = `${process.env.URL_API_BASE}${endPoint}${id}/alterar-senha`

  return axios
    .post(url, { senha }, config)
    .then(() => {
      page.$parent.$parent.$data.showModalLoader = false
      page.$router.push(pathRetorno)
    })
    .catch(error => {
      if (error.response && error.response.data.code) {
        page.errorMessage = error.response.data.error
      } else {
        console.log(error.message)
        page.errorMessage = 'Ocorreu um erro ao alterar a senha.'
      }

      page.$parent.$parent.$data.showModalLoader = false
    })
}

const listarUsuarioBackoffice = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + endPoint + 'listar-por-sistema/1',
    config
  )
  return response.data
}

const listarUsuarioPontoApoio = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + endPoint + 'listar-por-sistema/1',
    config
  )
  return response.data
}

const obterUsuario = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + endPoint + id,
    config
  )
  return response.data
}

const verificarEmailEmUso = async (email, sistema, cdUsuario = null) => {
  let response = await axios.get(
    process.env.URL_API_BASE +
      endPoint +
      'verificar-email-utilizado/' +
      sistema +
      '/' +
      email,
    config
  )
  if (cdUsuario !== null) {
    if (response.data.existe) {
      return !response.data.cd_usuario.includes(parseInt(cdUsuario))
    }
  }
  return response.data.existe
}

const verificarEmailEmUsoBackoffice = (email, cdUsuario = null) => {
  return verificarEmailEmUso(email, 1, cdUsuario)
}

const verificarEmailEmUsoPontoApoio = (email, cdUsuario = null) => {
  return verificarEmailEmUso(email, 3, cdUsuario)
}

export default {
  cadastrarUsuario,
  alterarUsuario,
  alterarSenha,
  listarUsuarioBackoffice,
  listarUsuarioPontoApoio,
  obterUsuario,
  verificarEmailEmUsoBackoffice,
  verificarEmailEmUsoPontoApoio
}



// WEBPACK FOOTER //
// ./src/actions/UsuarioActions.js